import React, { useEffect, useRef, useState } from "react";

// import { makeStyles } from '@material-ui/core/styles';
import ClearIcon from "@mui/icons-material/Clear";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import { getPetNameByWorkspaceId } from "../../../Api/Services/PetServices";
import {
  getAllVetPractice,
  getbyIDVetTherapist,
  getVetByPracticeID,
  getPetVetTherapistById,
  getVetById,
  updateVetPractice,
  updateVetTherapist,
} from "../../../Api/Services/VetServices";
import { useAuth } from "../../../ContextProvider/AuthProvider/AuthProvider";
import {
  FormHeaderBox,
  FormHeaderTitle,
  Body,
  Column,
  ButtonBoxStyle,
  CancelButton,
} from "../../../Css";
import { VetAndTherapistFormValidation, EditVetAndTherapistFormValidation } from "../../../From/Validation";
import { typeOptions } from "../../../Options";
import { getCountryAsOption, getStateAsOptions } from "../../../Utils";
import AutoComplete from "../../Common/AutoComplete";
import AutoCompleteAddress from "../../Common/AutoCompleteAddress";
import CustomButton from "../../Common/Button";
import FormGroup from "../../Common/FormGroup";
import FormLayout from "../../Common/FormHeader";
import InputField from "../../Common/InputField";
import CustomPhoneInput from "../../Common/PhoneInput";
import  { showSnackbar } from "../../Common/Snackbar";
import { useTheme } from "@mui/material/styles";

import "./form.css";
import "react-phone-input-2/lib/style.css";
import "../../pet-information/petPrint.css";

// const useStyles = makeStyles((theme) => ({
//   input: {
//     letterSpacing: '2px', // Adjust the spacing as needed
//   },
// }));
const defaultValue = {
  pet_id: "",
  vet_id: "",
  vet_full_name: "",
  vet_practice_id: "",
  email: "",
  fax: "",
  primary_phone_number: "",
  type: "",
  zip_code: "",
  street_address: "",
  street_address_2: "",
  city: "",
  country: "",
  state: "",
  vet_practice_name: "",
  vet_portal: "",
};

export default function VetForm() {
  const [initialValue, setInitialValue] = useState(defaultValue);
  const formikRef = useRef(null);
  const componentPDF = useRef();
  const navigate = useNavigate();
  const { id } = useParams();
  const theme = useTheme();

  // Determine if this is edit mode
  const isEditMode = !!id;

  const [shoefield, setShoefield] = useState(false);
  const [shvet, setShVet] = useState(false);
  const [readonly, setReadonly] = useState(false);

  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const [petName, setPetName] = useState([]);
  const [vetpracticename, setVetPracticeName] = useState([]);
  const [vetname, setVetName] = useState([
    { value: "vet", label: "Add A New Vet" },
  ]);
  const { workspaceId: w_id } = useAuth();
  // const classes = useStyles();

  const getPetNames = async () => {
    try {
      const res = await getPetNameByWorkspaceId(w_id);
      const filteredData = res?.data?.data?.map((item) => {
        return {
          value: item?.id,
          label: item?.name,
        };
      });
      
      if (filteredData?.length > 0) {
        setPetName(filteredData);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getVetPracticeName = async () => {
    try {
      const res = await getAllVetPractice(w_id);
      const uniqueValues = res?.data?.data?.filter(
        (obj, index, self) =>
          index === self.findIndex((el) => el.id === obj.id)
      );
      
      const vetnam = uniqueValues?.map((vet) => {
        return {
          value: vet?.id,
          label: vet?.vet_practice_name,
        };
      });
      
      // Only add "Add A New Practice" option in add mode
      if (!isEditMode) {
        vetnam?.push({ value: "other", label: "Add A New Practice" });
      }
      
      if (vetnam.length > 0) {
        setVetPracticeName(vetnam);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Load existing data for edit mode
  const loadVetDetails = async () => {
    if (!isEditMode) return;
    
    try {
      const res = await getPetVetTherapistById(id);
      const resData = res.data.data[0];
      const vetRes = await getVetById(resData?.vet_id);
      const vetData = vetRes?.data?.data?.[0];
      
      setInitialValue({
        ...initialValue,
        pet_id: resData?.pet_id,
        vet_id: resData?.vet_id,
        vet_full_name: vetData?.vet_full_name,
        vet_practice_id: vetData?.vet_practice_id,
        email: vetData?.email,
        fax: vetData?.fax,
        primary_phone_number: vetData?.primary_phone_number,
        type: vetData?.type,
        zip_code: vetData?.zip_code,
        street_address: vetData?.street_address,
        street_address_2: vetData?.street_address_2,
        city: vetData?.city,
        country: vetData?.country,
        state: vetData?.state,
        vet_practice_name: "",
        vet_portal: vetData?.vet_portal,
      });

      // Set country and state options
      const country = getCountryAsOption();
      setCountryOptions(country);
      const countryCode = country?.find(
        (country) => country.label === vetData?.country
      );
      const state = getStateAsOptions(countryCode?.isoCode);
      const filteredState = state?.map((item) => ({
        value: item.label,
        label: item.label,
      }));
      filteredState.push({ value: "Other", label: "Other" });
      setStateOptions(filteredState);
    } catch (err) {
      console.error(err);
      showSnackbar({
        type: "error",
        message: "Failed to load vet details.",
      });
    }
  };

  useEffect(() => {
    if (w_id) {
      getPetNames();
      getVetPracticeName();
      if (isEditMode) {
        loadVetDetails();
      }
    }
  }, [w_id, isEditMode]);

 

  // Update existing vet therapist
  const updateVetTherapistData = async (values) => {
    const vetData = {
      name: values?.pet_id,
      vet_full_name: values?.vet_full_name,
      vet_practice_id: values?.vet_practice_id,
      email: values?.email,
      fax: values?.fax,
      primary_phone_number: values?.primary_phone_number,
      type: values?.type,
      zip_code: values?.zip_code,
      street_address: values?.street_address,
      street_address_2: values?.street_address_2,
      city: values?.city,
      country: values?.country,
      state: values?.state,
      vet_portal: values?.vet_portal,
      pet_vet_id: id,
    };
    
    const practiceData = {
      vet_practice_name: values?.vet_practice_name,
    };
    
    await Promise.all([
      updateVetTherapist(values?.vet_id, vetData),
      updateVetPractice(values?.vet_practice_id, practiceData),
    ]);
    
    return { success: true };
  };

  const sendData = async (values, { isSubmitting }) => {
    try {
      if (isEditMode) {
        await updateVetTherapistData(values);
        showSnackbar({
          type: "success",
          message: "Vet therapist updated successfully.",
        });
      } else {
        showSnackbar({
          type: "success",
          message: "Vet therapist added successfully.",
        });
      }
    } catch (err) {
      showSnackbar({
        type: "error",
        message: isEditMode ? "Vet therapist update failed." : "Vet therapist add failed.",
      });
    } finally {
      isSubmitting(false);
    }
  };

  const handleVetPracNameSelector = async (e, newvalue) => {
    if (newvalue?.value === "other") {
      setShoefield(true);
      setReadonly(false);
      setVetName([{ value: "vet", label: "Add A New Vet" }]);
    } else {
      setShoefield(false);
      //   setReadonly(true);
      try {
        const res = await getVetByPracticeID(newvalue?.value);
        const nam = res?.data?.data?.map((vet) => {
          return {
            value: vet?.id,
            label: vet?.vet_full_name,
          };
        });
        
        if (nam.length > 0) {
          nam?.push({ value: "vet", label: "Add A New Vet" });
          setVetName(nam);
        } else {
          setVetName([{ value: "vet", label: "Add A New Vet" }]);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleVetName = async (e, newvalue) => {
    formikRef.current.setFieldValue("vet_id", newvalue?.value);
    if (newvalue?.value === "vet") {
      setShVet(true);
      setReadonly(false);

      setInitialValue({
        ...formikRef.current?.values,
        vet_id: newvalue?.value,
        vet_full_name: "",
        email: "",
        fax: "",
        primary_phone_number: "",
        // type: "",
        zip_code: "",
        street_address: "",
        street_address_2: "",
        city: "",
        country: "",
        state: "",
      });
    } else {
      setShVet(false);
      setReadonly(true);
      try {
        const res = await getbyIDVetTherapist(newvalue?.value);
        const data = res.data.data[0];
        setInitialValue({
          ...formikRef.current?.values,
          ...data,
        });
      } catch (err) {
        showSnackbar({
          type: "error",
          message: "Vet therapist add failed.",
        });
      }
    }
  };

  useEffect(() => {
    const country = getCountryAsOption();
    setCountryOptions(country);
  }, []);

  const handleCountryChange = (e, newValue) => {
    const state = getStateAsOptions(newValue?.isoCode);
    const filteredState = state?.map((item) => {
      return {
        value: item.label,
        label: item.label,
      };
    });
    filteredState.push({ value: "Other", label: "Other" });
    setStateOptions(filteredState);
    formikRef?.current?.setFieldValue("state", "");
  };

  const handleFaxNumberChange = (e) => {
    // Remove non-numeric characters
    const formattedFax = e.target.value.replace(/\D/g, "");

    // Format the fax number as +1 (123) 456-7890
    let formattedValue = "";
    if (formattedFax.length >= 1) {
      formattedValue += `+${formattedFax[0]}`;
    }
    if (formattedFax.length >= 2) {
      formattedValue += ` (${formattedFax.substring(1, 4)}`;
    }
    if (formattedFax.length >= 5) {
      formattedValue += `) ${formattedFax.substring(4, 7)}`;
    }
    if (formattedFax.length >= 8) {
      formattedValue += `-${formattedFax.substring(7, 11)}`;
    }
    formikRef?.current?.setFieldValue("fax", formattedValue);
  };

  // Handle print functionality
  const handlePrint = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Vet therapist",
    pageStyle: `
      @page { size: A3; margin: 200px; }
      body { margin: 100px; }
      .print-text-field { font-size: 14px; }
    `,
  });

  return (
    <FormLayout title={isEditMode ? "Edit Vet and Therapist Information" : "Vet and Therapist Information"}>
      <Formik
        initialValues={initialValue}
        innerRef={formikRef}
        onSubmit={sendData}
        validationSchema={isEditMode ? EditVetAndTherapistFormValidation : VetAndTherapistFormValidation}
        validateOnMount={false}
        enableReinitialize
      >
        {({ getFieldProps, values, setFieldValue, isSubmitting }) => (
          <Form>
            <Box sx={FormHeaderBox(theme.palette.primary.main)}>
              <div ref={componentPDF} style={{ width: "100%", height: "100%" }}>
                <Box className="scroll2" sx={{ width: "100%" }}>
                  <Box sx={{ borderBottom: `1px solid ${theme.palette.primary.main}`, width: "100%" }}>
                    <Typography variant="h6" sx={FormHeaderTitle}>
                      Vet and Therapist Details 
                    </Typography>
                  </Box>
                  <Body style={{ gap: "10px 20px", marginTop: "10px" }}>
                    <Column>
                      <FormGroup name="pet_id" label={"Pet Name"} requiredField>
                        <AutoComplete
                          {...getFieldProps("pet_id")}
                          options={petName}
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      {!isEditMode && shoefield ? (
                        <FormGroup
                          name="vet_practice_name"
                          label={"Veterinary Practice"}
                        >
                          <InputField
                            {...getFieldProps("vet_practice_name")}
                            InputProps={{
                              endAdornment: (
                                <IconButton
                                  position="end"
                                  onClick={() => {
                                    setShoefield(false);
                                    setFieldValue("vet_practice_id", "");
                                    setFieldValue("vet_practice_name", "");
                                  }}
                                  sx={{
                                    color: "#fff",
                                    backgroundColor: "transparent",
                                    zIndex: 1,
                                    padding: 0,
                                    cursor: "pointer",
                                    width: "auto"
                                  }}
                                >
                                  <ClearIcon
                                    sx={{ backgroundColor:`${theme.palette.primary.main}` }}
                                  />
                                </IconButton>
                              ),
                            }}
                          />
                        </FormGroup>
                      ) : (
                        <FormGroup
                          name="vet_practice_id"
                          label={"Veterinary Practice"}
                          requiredField
                        >
                          <AutoComplete
                            {...getFieldProps("vet_practice_id")}
                            options={vetpracticename}
                            onChange={!isEditMode ? handleVetPracNameSelector : undefined}
                            isOnChange={!isEditMode}
                          />
                        </FormGroup>
                      )}
                    </Column>
                    <Column>
                      {!isEditMode && shvet ? (
                        <FormGroup
                          name="vet_full_name"
                          label={"New Vet Full Name"}
                        >
                          <InputField
                            {...getFieldProps("vet_full_name")}
                            InputProps={{
                              endAdornment: (
                                <IconButton
                                  position="end"
                                  onClick={() => {
                                    setShVet(false);
                                    setFieldValue("vet_id", "");
                                    setFieldValue("vet_full_name", "");
                                  }}
                                  sx={{
                                    color: "#fff",
                                    backgroundColor: "transparent",
                                    zIndex: 1,
                                    padding: 0,
                                    cursor: "pointer",
                                    width: "auto"
                                  }}
                                >
                                  <ClearIcon
                                    sx={{ backgroundColor: `${theme.palette.primary.main}` }}
                                  />
                                </IconButton>
                              ),
                            }}
                          />
                        </FormGroup>
                      ) : (
                        <FormGroup
                          name={isEditMode ? "vet_full_name" : "vet_id"}
                          label={"Vet Full Name"}
                          requiredField
                        >
                          {isEditMode ? (
                            <InputField {...getFieldProps("vet_full_name")} />
                          ) : (
                            <AutoComplete
                              {...getFieldProps("vet_id")}
                              // otherType="vet"
                              options={vetname}
                              onChange={handleVetName}
                              isOnChange
                            />
                          )}
                        </FormGroup>
                      )}
                    </Column>
                    <Column>
                      <FormGroup name="type" label={"Type"} requiredField>
                        <AutoComplete
                          {...getFieldProps("type")}
                          options={typeOptions}
                          placeholder={"Select a type"}
                          otherType="Other"
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="fax" label={"Fax"}>
                        <InputField
                          {...getFieldProps("fax")}
                          onChange={handleFaxNumberChange}
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="vet_portal" label={"Vet Portal"}>
                        <InputField
                          {...getFieldProps("vet_portal")}
                          InputProps={{
                            readOnly: readonly,
                          }}
                        />
                      </FormGroup>
                    </Column>
                  </Body>
                  <Box
                    sx={{
                      borderBottom: `1px solid 1px solid ${theme.palette.primary.main}`,
                      width: "100%",
                      marginTop: "20px",
                    }}
                  >
                    <Typography variant="h6" sx={FormHeaderTitle}>
                      Contact Details
                    </Typography>
                  </Box>
                  <Body style={{ gap: "10px 20px", marginTop: "10px" }}>
                  <Column>
                      <FormGroup
                        name="email"
                        label={"Email Address"}
                        requiredField
                      >
                        <InputField {...getFieldProps("email")} />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup
                        name="primary_phone_number"
                        label={"Phone Number"}
                        requiredField
                      >
                        <CustomPhoneInput
                          {...getFieldProps("primary_phone_number")}
                          
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="street_address" label={"Street Address"}>
                        <AutoCompleteAddress
                          formikRef={formikRef}
                          setFieldValue={setFieldValue}
                          value={values?.street_address}
                          address="street_address"
                          city="city"
                          state="state"
                          zipcode="zip_code"
                          country="country"
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup
                        name="street_address_2"
                        label={"Street Address 2"}
                      >
                        <InputField
                          {...getFieldProps("street_address_2")}
                          InputProps={{
                            readOnly: readonly,
                          }}
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="country" label={"Country"}>
                        <AutoComplete
                          {...getFieldProps("country")}
                          name="country"
                          options={countryOptions}
                          placeholder="Select a country"
                          onChange={handleCountryChange}
                          isOnChange
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="state" label={"State"}>
                        <AutoComplete
                          {...getFieldProps("state")}
                          name="state"
                          otherType="Other"
                          options={stateOptions}
                          placeholder={"Select a State"}
                          readOnly={readonly}
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="city" label={"City"}>
                        <InputField
                          {...getFieldProps("city")}
                          InputProps={{
                            readOnly: readonly,
                          }}
                        />
                      </FormGroup>
                    </Column>
                    <Column>
                      <FormGroup name="zip_code" label={"Zip Code"}>
                        <InputField
                          {...getFieldProps("zip_code")}
                          InputProps={{
                            readOnly: readonly,
                          }}
                        />
                      </FormGroup>
                    </Column>
                  </Body>
                </Box>
              </div>
              {/* </Wrapper> */}
              <Box sx={ButtonBoxStyle(`${theme.palette.primary.main}`)}>
                <CustomButton
                  label="Cancel"
                  type="button"
                  style={CancelButton(`${theme.palette.primary.main}`)}
                  onClick={() => navigate(-1)}
                />
                <CustomButton
                  label={isSubmitting ? (isEditMode ? "Saving..." : "Submitting...") : (isEditMode ? "Save" : "Submit")}
                  disabled={isSubmitting}
                  type="submit"
                />
                {isEditMode && (
                  <CustomButton
                    startIcon={<LocalPrintshopOutlinedIcon />}
                    onClick={handlePrint}
                  />
                )}
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
    </FormLayout>
  );
}
